import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../utils/interceptorsToken';



export const authService = createApi({
    reducerPath: 'authService',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => {
        return {
            register: builder.mutation({
                query: (data) => {
                    return {
                        url: '/auth/register',
                        method: 'POST',
                        body: data
                    };
                },
            }),
            login: builder.mutation({
                query: (data) => {
                    return {
                        url: '/auth/login',
                        method: 'POST',
                        body: data
                    };
                },
                invalidatesTags: ['USER']
            }),
            logout: builder.mutation({
                query: () => {
                    return {
                        url: '/auth/logout',
                        method: 'POST',
                    };
                },
                invalidatesTags: ['USER']
            }),
            forgotPassword: builder.mutation({
                query: (email) => {
                    return {
                        url: '/auth/forgot-password',
                        method: 'POST',
                        body: email
                    };
                },
                invalidatesTags: ['USER']
            }),
            resetPassword: builder.mutation({
                query: (data) => {
                    return {
                        url: `/auth/reset-password/${data.id}/${data.token}`,
                        method: 'POST',
                        body: { password: data.password }
                    };
                },
                invalidatesTags: ['USER']
            }),
            changePassword: builder.mutation({
                query: (data) => {
                    return {
                        url: '/auth/change-password',
                        method: 'POST',
                        body: data
                    };
                }
            })
        };
    },
});

export const { useRegisterMutation, useLoginMutation, useLogoutMutation, useForgotPasswordMutation, useResetPasswordMutation, useChangePasswordMutation } = authService;